import getEnvironmentSettings from '../../commons/configs/env-conf-loader';
import { OnInit } from "@angular/core";

export interface ErrorComponentBase {
  error: { [key: string]: any };
  errorDetails: string;
  ngOnInit(): void;
}

export function ErrorComponentBase<T extends { new(...args: any[]): {} }>(
  constructor: T
) {
  return class extends constructor implements ErrorComponentBase, OnInit {

    error: { [key: string]: any };
    errorDetails: string = '';

    private readonly _environments = ["Localhost", "Local", "Development"];
    private readonly _Env: string = getEnvironmentSettings().name;

    ngOnInit(): void {
      if (this.error && this._environments.includes(this._Env)) {
        this.errorDetails = this._getErrorDetails(this.error);
      }
    }

    private _getErrorDetails(rejection: { [key: string]: any }): string {
      return JSON.stringify(rejection, null, 2).replace(/"([a-zA-Z0-9$_]+)":/g, '$1:');;
    }
  };
}
